import React from "react";
import { Link } from "react-router-dom";
import "../Styling/Navbar.css"; // create a separate CSS file for styling

const Navbar = () => {
  return (
    <nav className="sandbox-navbar">
      <div className="sandbox-navbar-logo">
        <span>Digital Dreamworks Agency</span>
      </div>
      <ul className="sandbox-navbar-links">
        <li>
          <Link to="/Dashboard" className="sandbox-navbar-link">
            Home
          </Link>
        </li>
        <li>
          <Link to="/" className="sandbox-navbar-link">
            Log Out
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
